import cookie from "js-cookie";

export function getCookie(cname: string) {
  return cookie.get(cname);
}
